import _ from 'lodash';
import React from 'react';
import { ButtonLight, ButtonStandard, MultiSelectComboBox, formatMessage, Flexbox } from 'cw-ui-core';
import Locale from 'src/i18n';

import css from 'src/features/users/components/UserGridFilters/UserGridFilters.scss';
import Shimmer from 'src/components/Shimmer/Shimmer';
import { MFA_FILTER, AUTHENTICATION_FILTER, LOCAL_LOGIN } from 'src/constants';

const UserGridFilters = ({
    onReset,
    onApply,
    data,
    setValueInDropdown,
    connectedAppsIsLoading,
    onConnectedAppsFilterClick,
    connectedAppsId,
}) => {
    const checkLocalLogin = () => {
        const authenticationSelected = data?.find(x => x?.id === AUTHENTICATION_FILTER)?.selectedValue;
        return _.isEmpty(authenticationSelected) ? false : !_.includes(authenticationSelected, LOCAL_LOGIN);
    };
    const isMfaSelected = !_.isEmpty(data?.find(x => x?.id === MFA_FILTER)?.selectedValue);

    return (
        <Flexbox column className={css.wrap}>
            {data.map(filter => {
                return filter.id === connectedAppsId ? (
                    <Shimmer isLoading={connectedAppsIsLoading} shimmerClassName={css.appsFilterShimmer}>
                        <MultiSelectComboBox
                            cwId={filter.id}
                            automationName={filter.id}
                            className={css.multiSelectDropdown}
                            key={filter.id}
                            items={filter.filterList}
                            placeholder={filter.placeholder}
                            value={filter.selectedValue}
                            onChange={value => setValueInDropdown(value, filter.id)}
                            onExpand={onConnectedAppsFilterClick}
                        />
                    </Shimmer>
                ) : (
                    <MultiSelectComboBox
                        cwId={filter.id}
                        automationName={filter.id}
                        className={css.multiSelectDropdown}
                        key={filter.id}
                        items={filter.filterList}
                        placeholder={filter.placeholder}
                        value={filter.selectedValue}
                        disabled={
                            (filter?.id === AUTHENTICATION_FILTER && isMfaSelected && checkLocalLogin()) ||
                            (filter?.id === MFA_FILTER && checkLocalLogin())
                        }
                        onChange={value => setValueInDropdown(value, filter.id)}
                    />
                );
            })}
            <Flexbox className={css.filterActions}>
                <ButtonLight
                    key="reset"
                    automationName="reset"
                    className={css.resetButton}
                    value={formatMessage(Locale.reset)}
                    onClick={onReset}
                />
                <ButtonStandard
                    key="apply"
                    automationName="apply"
                    className={css.applyButton}
                    value={formatMessage(Locale.apply)}
                    onClick={onApply}
                />
            </Flexbox>
        </Flexbox>
    );
};

export default UserGridFilters;
